export const staticMapStyles = ['feature:poi.business|visibility:off'];

export const globeStaticMapStyles = [
  'feature:administrative|element:geometry.stroke|color:0xffffff',
  'feature:landscape|saturation:-65|lightness:-13|gamma:1|hue:0xffd500',
  'feature:landscape|element:geometry.stroke|color:0xffffff',
  'feature:water|saturation:-72|lightness:39|gamma:1|color:0xcededa',
];
